import { render, staticRenderFns } from "./FileResultCardCollapse.vue?vue&type=template&id=2716d0ee&scoped=true"
import script from "./FileResultCardCollapse.vue?vue&type=script&lang=ts"
export * from "./FileResultCardCollapse.vue?vue&type=script&lang=ts"
import style0 from "./FileResultCardCollapse.vue?vue&type=style&index=0&id=2716d0ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2716d0ee",
  null
  
)

export default component.exports